export const AssetType = {
  MEMBERSHIP: 'membership',
  DECOM: 'decom',
  CRED: 'cred',
  CREDENZA_ASSET_COLLECTION: 'credenza_asset_collection',
}

export type TPaymentAsset = {
  type: string
  packageId: string
  amount?: number
  assetId?: string
  metadata?: any
}
